export function getCookie(name: string) {
  const value = '; ' + document.cookie;
  const parts = value.split('; ' + name + '=');
  if (parts == null || parts.length < 2) {
    return '';
  }

  const popped = parts.pop();
  if (popped == null || popped.length === 0) {
    return '';
  }

  return popped.split(';').shift();
}
